import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CreateSkLkrlEffect } from './create-sk-lkrl.effect';
import { createSkLkrlReducer } from './create-sk-lkrl.reducer';
import { CREATE_SK_LKRL_STORE_NAME, CreateSkLkrlState } from './create-sk-lkrl.state';

/** Token of the CreateSkLkrl reducer */
export const CREATE_SK_LKRL_REDUCER_TOKEN = new InjectionToken<ActionReducer<CreateSkLkrlState, Action>>(
  'Feature CreateSkLkrl Reducer'
);

/** Provide default reducer for CreateSkLkrl store */
export function getDefaultCreateSkLkrlReducer() {
  return createSkLkrlReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CREATE_SK_LKRL_STORE_NAME, CREATE_SK_LKRL_REDUCER_TOKEN),
    EffectsModule.forFeature([CreateSkLkrlEffect]),
  ],
  providers: [{ provide: CREATE_SK_LKRL_REDUCER_TOKEN, useFactory: getDefaultCreateSkLkrlReducer }],
})
export class CreateSkLkrlStoreModule {
  public static forRoot<T extends CreateSkLkrlState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CreateSkLkrlStoreModule> {
    return {
      ngModule: CreateSkLkrlStoreModule,
      providers: [{ provide: CREATE_SK_LKRL_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
